import { Routes, Route } from 'react-router-dom';

// project-imports
import LoginRoutes from './LoginRoutes';
import AppsRoutes from './AppsRoutes';
import ErrorRoutes from './ErrorRoutes';

// ==============================|| ROUTES RENDER ||============================== //

export default function ThemeRoutes() {
  return (
    <Routes>
      <Route
        path="/"
        element={LoginRoutes.children[0].element}
      >
        {LoginRoutes.children[0].children?.map((childRoute) => (
          <Route
            key={childRoute.path}
            path={childRoute.path}
            element={childRoute.element}
          />
        ))}
      </Route>
      <Route
        path="/"
        element={AppsRoutes.children[0].element}
      >
        {AppsRoutes.children[0].children?.map((childRoute) => (
          <Route
            key={childRoute.path}
            path={childRoute.path}
            element={childRoute.element}
          >
            {childRoute.children?.map((nestedRoute) => (
              <Route
                key={nestedRoute.path}
                path={nestedRoute.path}
                element={nestedRoute.element}
              />
            ))}
          </Route>
        ))}
      </Route>
      <Route
        path={ErrorRoutes.path}
        element={ErrorRoutes.element}
      />
      <Route
        path="*"
        element={LoginRoutes.children[1].element}
      />
    </Routes>
  );
}
